import { render } from "./modalTerms.vue?vue&type=template&id=98da2b9e&scoped=true"
import script from "./modalTerms.vue?vue&type=script&lang=js"
export * from "./modalTerms.vue?vue&type=script&lang=js"

import "./modalTerms.vue?vue&type=style&index=0&id=98da2b9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98da2b9e"]])

export default __exports__